module.exports = __webpack_public_path__ + "static/media/jerry.e6f0fcb6.png";